<template>
  <div>
    <form @submit.prevent="submit" v-if="!success">
      <h5 class="title text-black">Send us a message</h5>

      <md-field>
        <label>Name</label>
        <md-input v-model="data.inputs.name" required type="text" />
      </md-field>

      <md-field>
        <label>Email</label>
        <md-input v-model="data.inputs.email" required type="email" />
      </md-field>

      <md-field>
        <label>Phone</label>
        <md-input v-model="data.inputs.phone" type="text" />
      </md-field>

      <md-field>
        <label>Message</label>
        <md-textarea v-model="data.inputs.message" required></md-textarea>
      </md-field>

      <div class="button-container justify-content-center">
        <!-- Removed @click="recaptcha" which caused errors if recaptcha method was missing.
             Keep type="submit" so @submit.prevent on form triggers submit(). -->
        <md-button
          class="md-danger mt-3"
          type="submit"
          :disabled="sending"
        >
          <span v-if="!sending">Send</span>
          <span v-else>Sending…</span>
        </md-button>
      </div>
    </form>

    <div class="messages">
      <div v-if="success">
        <h4>Your message has been sent, we will be in touch soon.</h4>
        <md-button class="md-danger" @click="resetForm">Reset Form</md-button>
      </div>

      <div v-if="sending"><h4>Sending your message now.</h4></div>

      <div v-if="error"><h4>There was an unknown issue sending your message, please wait and try again later, thanks.</h4></div>
    </div>
  </div>
</template>

<script>
import env from '/src/env.json';

export default {
  name: "Form",

  data() {
    return {
      success: false,
      error: false,
      sending: false,
      data: {
        inputs: {
          name: "",
          email: "",
          phone: "",
          message: ""
        },
      }
    };
  },

  methods: {
    resetForm() {
      this.data = {
        inputs: {
          name: "",
          email: "",
          phone: "",
          message: ""
        }
      };
      this.success = false;
      this.error = false;
      this.sending = false;
    },

    async submit() {
      this.error = false;
      try {
        this.sending = true;

        // Ensure plugin loaded
        if (typeof this.$recaptchaLoaded === 'function') {
          await this.$recaptchaLoaded();
        }

        // Run reCAPTCHA (safe fallback if $recaptcha isn't available)
        let token = null;
        if (typeof this.$recaptcha === 'function') {
          // action name can be anything; "contact_form" is descriptive
          token = await this.$recaptcha('contact_form');
        } else {
          // If recaptcha plugin not installed for some reason, continue without token
          // eslint-disable-next-line no-console
          console.warn('reCAPTCHA not available; sending without token.');
        }

        const payload = {
          HandlerID: "NZDRT_ContactForm",
          Packet: {
            ...this.data.inputs,
            // Include Recaptcha token only if present
            ...(token ? { RecaptchaToken: token } : {}),
            AndTo: [
              { Email: this.data.inputs.email }
            ]
          }
        };

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": env.kea.xApiKey,
            "PrimaryDomain": env.primaryDomain,
          },
          body: JSON.stringify(payload)
        };

        const url = `${env.kea.url}/${env.application}/chirp/public`;
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
          // try to get response body for more context (but don't assume JSON)
          let text;
          try { text = await response.text(); } catch (_) { text = ''; }
          throw new Error(`Chirp request failed (${response.status}) ${text}`);
        }

        // success
        this.success = true;
        this.error = false;
      } catch (err) {
        // Log and show friendly UI
        // (console.error is safe; avoids document.write which breaks SPA)
        // eslint-disable-next-line no-console
        console.error('Contact form submit error:', err);
        this.error = true;
        this.success = false;
      } finally {
        this.sending = false;
      }
    }
  }
};
</script>

<style scoped>
.messages{
  text-align:center;
  color:red;
}
</style>
